import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take, tap, switchMap } from 'rxjs';

import { SocketService } from '@core/services/socket.service';
import { AuthService } from '@core/services/auth.service';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  setAuthModal,
  updateUserPreferenceActionSuccess,
} from '@state/auth/auth.actions';

@UntilDestroy()
@Component({
  selector: 'app-auth-account-setup',
  templateUrl: './account-setup.component.html',
  styleUrls: ['./account-setup.component.scss'],
})
export class AccountSetupComponent implements OnInit {
  constructor(
    private socketService: SocketService,
    private authService: AuthService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    // this.hotjarService.callEvent('start_account_setup');

    this.socketService.ready$
      .pipe(
        filter((ready) => ready),
        tap(() => {
          console.log(
            'Socket ready, subscribing to user verification status...'
          );
        }),
        take(1),
        switchMap(() => this.authService.subscribeToUserUpdate()),
        untilDestroyed(this)
      )
      .subscribe({
        next: (user) => {
          console.log('new user data received via WS:', user);
          if (user.updated.preference) {
            this.store.dispatch(
              updateUserPreferenceActionSuccess({
                preference: user.updated.preference,
              })
            );
            this.store.dispatch(setAuthModal({ authModal: undefined }));
          }
        },
        error: (error) => {
          console.error(
            'Error subscribing to user verification status:',
            error
          );
        },
      });
  }
}
